import {getParams, proFetch} from '@/utils/fetch';

// 查询汉字分组
export function getPlayWordGroupList() {

    return proFetch({
        url: 'structure/playWord/getPlayWordGroupList',
        method: 'GET'
    });
}

// 根据分组id查询字库列表
export function getPlayWordGroupStockList(args) {
    const params = getParams();
    params.append('groupId', args.groupId);
    return proFetch({
        url: 'structure/playWord/getPlayWordGroupStockList',
        method: 'GET',
        params
    });
}
// 新增汉字分组
export function addPlayWordGroup(args) {
    const params = getParams();
    params.append('orderNum', args.orderNum);
    params.append('remark', args.remark);
    params.append('title', args.title);

    return proFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/playWord/addPlayWordGroup',
        method: 'POST',
        data: JSON.stringify(args)
    });
}
// 修改汉字分组
export function updatePlayWordGroup(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('orderNum', args.orderNum);
    params.append('remark', args.remark);
    params.append('title', args.title);

    return proFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/playWord/updatePlayWordGroup',
        method: 'POST',
        data: JSON.stringify(args)
    });
}

// 根据分组id删除汉字分组
export function delPlayWordGroup(args) {
    const params = getParams();
    params.append('groupId', args.groupId);

    return proFetch({
        url: 'structure/playWord/delPlayWordGroup',
        method: 'GET',
        params
    });
}
// 查询汉字分组
export function getPlayWordGroupById(args) {
    const params = getParams();
    params.append('groupId', args.groupId);

    return proFetch({
        url: 'structure/playWord/getPlayWordGroupById',
        method: 'GET',
        params
    });
}
// 批量新增汉字字库
export function addPlayWordGroupStockList(args) {

    return proFetch({
        url: 'structure/playWord/addPlayWordGroupStockList',
        method: 'POST',
        data: args
    });
}

// 根据汉字ids批量删除汉字字库
export function delPlayWordGroupStockByIds(args) {
    const params = getParams();
    params.append('stockIds', args.stockIds);

    return proFetch({
        url: 'structure/playWord/delPlayWordGroupStockByIds',
        method: 'GET',
        params
    });
}
// 批量移动汉字字库
export function movePlayWordGroupStockList(args) {
    const params = getParams();
    params.append('groupId', args.groupId);
    params.append('stockIds', args.stockIds);

    return proFetch({
        url: 'structure/playWord/movePlayWordGroupStockList',
        method: 'GET',
        params
    });
}
// 根据汉字名称查询字库信息
export function getPlayWordGroupStockByName(args) {
    const params = getParams();
    params.append('wordName', args.wordName);

    return proFetch({
        url: 'structure/playWord/getPlayWordGroupStockByName',
        method: 'GET',
        params
    });
}
// 查询玩转汉字字库详情
export function getPlayWordGroupStockInfo(args) {
    const params = getParams();
    params.append('wordName', args.wordName);

    return proFetch({
        url: 'structure/playWord/getPlayWordGroupStockInfo',
        method: 'GET',
        params
    });
}
// 新增修改玩转汉字字库详情
export function addAndUpdatePlayWordGroupStockInfo(args) {

    return proFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/playWord/addAndUpdatePlayWordGroupStockInfo',
        method: 'POST',
        data: JSON.stringify(args)
    });
}



// WEBPACK FOOTER //
// ./src/api/chineseChar.js